import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export const Hero = () => {
  return <section className="relative pt-12 pb-20 md:pt-20 md:pb-32 px-5 md:px-8 overflow-hidden" data-id="element-97">
      {/* Background decorative elements */}
      <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] rounded-full bg-beige/50 blur-3xl -z-10" data-id="element-98"></div>
      <div className="absolute bottom-[-10%] right-[-5%] w-[30%] h-[30%] rounded-full bg-dustyRose/10 blur-3xl -z-10" data-id="element-99"></div>

      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-100">
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="order-2 lg:order-1 flex flex-col justify-center" data-id="element-101">
          <div className="inline-block bg-beige text-terracotta font-medium px-4 py-1.5 rounded-full text-sm mb-6 w-fit" data-id="element-102">
            Edición Especial USA
          </div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6 text-charcoal" data-id="element-103">
            El Escudo de los 3 Segundos:{' '}
            <span className="text-terracotta italic font-normal" data-id="element-104">
              Cómo Dejar de Gritar y Recuperar la Paz en tu Hogar
            </span>
          </h1>
          <h2 className="text-lg md:text-xl text-charcoal/80 leading-relaxed mb-10 font-light" data-id="element-105">
            El método práctico diseñado para madres latinas que viven bajo el
            estrés de USA, no tienen red de apoyo y están cansadas de sentirse
            culpables cada noche.
          </h2>

          <div className="w-full md:w-auto" data-id="element-106">
            <Button onClick={() => document.getElementById('offer')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-107">
              ¡QUIERO MI GUÍA Y RECUPERAR MI PAZ AHORA!
            </Button>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut',
        delay: 0.2
      }} className="order-1 lg:order-2 relative" data-id="element-108">
          <div className="relative rounded-2xl overflow-hidden shadow-2xl aspect-[4/5] md:aspect-square lg:aspect-[4/5] max-w-md mx-auto lg:max-w-none" data-id="element-109">
            <img src="https://cdn.magicpatterns.com/uploads/hy9NDcTBi85MEHT8658A97/Imagen_de_portada_de_guia_de_crianza_sin_gritos_nueva.png" alt="Madre e hijo sonriendo juntos - Portada de la guía" className="w-full h-full object-cover" data-id="element-110" />
            <div className="absolute inset-0 bg-gradient-to-t from-charcoal/20 to-transparent" data-id="element-111"></div>
          </div>
        </motion.div>
      </div>
    </section>;
};